<template>
  <div class="animated fadeIn">
    <!-- <div class="card p-4 mb-1">
      <div class="form-group row">
        <div class="col-md-12 text-left">
          <h6 class="text-third text-bold"><i class="fas fa-briefcase"></i> PRODUTOS <span v-if="!boardArchived" style="right: 17px;display: inline-block;position: absolute;cursor: pointer" @click="onAddProduct"><i class="fas fa-plus-circle"></i></span></h6>
        </div>
      </div> -->
    <div v-show="hasProducts">
      <!-- <div class="form-group row" v-if="false">
          <div class="col-md-12">
            <div class="table-responsive pt-2">
              <table v-if="products && products.length > 0" class="table table-hover" style="border: 1px solid #dcdede;">
                <thead class="thead-third" style="border: solid 1px #04a791;">
                  <tr>
                    <th class="text-center" style="font-size: 10px;">DATA</th>
                    <th class="text-center" style="font-size: 10px;">PRODUTO</th>
                    <th class="text-center" style="font-size: 10px;">VALOR</th>
                  </tr>
                </thead>
                <tbody v-if="products && products.length > 0">
                  <tr v-for="(obj, index) in products" :key="index">
                    <td class="text-center">{{ obj.nome }}</td>
                    <td class="text-center" style="font-size: 11px;">{{ obj.nome }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-else>
                Nenhum produto cadastrado, <strong @click="onAddProduct" style="cursor: pointer">clique para
                  adicionar</strong>
              </div>
            </div>
          </div>
        </div> -->
      <Tables ref="tableGrid" :columns="[
        $lang.Common.DataTable.ProductTable.Date,
        $lang.Common.DataTable.ProductTable.Product,
        $lang.Common.DataTable.ProductTable.Operation,
        $lang.Common.DataTable.ProductTable.DaysLate,
        $lang.Common.DataTable.ProductTable.Value,
        $lang.Common.DataTable.ProductTable.Observation,
        $lang.Common.DataTable.Actions
      ]" v-on:Load="onLoad" v-if="checkTypeBoard(card)">
        <tr v-for="obj in this.objList" v-bind:key="obj.id">
          <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.data" />
          <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1"
            :value="obj.produtoDTO ? obj.produtoDTO.nome : ''" />
          <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.operacao" />
          <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.diasAtraso.toString()" />
          <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="formatValue(obj.valor)" />
          <TableColumn :IsCustom="true">
            <td class="text-center text-third" style="font-size: 16px;border:0px;padding: 0px 0px 0px  35px; "
              v-if="obj.observacao">
              <span><strong v-b-tooltip.hover :title="obj.observacao"><i class="fas fa-comment"></i></strong></span>
            </td>
            <td class="text-center" style="font-size: 11px;border:0px;padding-top: 0px;" v-else>&nbsp;</td>
          </TableColumn>
          <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDelete(obj)" :status="obj.status" />
        </tr>
        <template slot="table-footer">
          <tr>
            <td colspan="3" class="text-right text-third"><strong><i class="fas fa-funnel-dollar text-third"></i>&nbsp;
                {{ formatValue(totalValue) }}</strong></td>
            <td colspan="2">&nbsp;</td>
          </tr>
        </template>
      </Tables>
      <Tables
          ref="tableGrid"
          :columns="[
            $lang.Common.DataTable.ProductTable.Date,
            $lang.Common.DataTable.ProductTable.Product,
            $lang.Common.DataTable.ProductTable.Value,
            $lang.Common.DataTable.ProductTable.Observation,
            $lang.Common.DataTable.Actions
          ]"
          v-on:Load="onLoad"
          v-else
        >
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.data" />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="1" :value="obj.produtoDTO ? obj.produtoDTO.nome : ''" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="formatValue(obj.valor)" />
            <TableColumn :IsCustom="true">
              <td class="text-center text-third" style="font-size: 16px;border:0px;padding: 0px 0px 0px  35px; " v-if="obj.observacao">
                <span><strong v-b-tooltip.hover :title="obj.observacao"><i class="fas fa-comment"></i></strong></span>
              </td>
              <td class="text-center" style="font-size: 11px;border:0px;padding-top: 0px;" v-else>&nbsp;</td>
            </TableColumn>
            <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDelete(obj)" :status="obj.status" />
          </tr>
          <template slot="table-footer">
            <tr>
              <td colspan="3" class="text-right text-third"><strong><i class="fas fa-funnel-dollar text-third"></i>&nbsp; {{formatValue(totalValue)}}</strong></td>
              <td colspan="2">&nbsp;</td>
            </tr>
          </template>
        </Tables>
    </div>
    <div v-show="!hasProducts">
      Nenhum produto cadastrado, <strong @click="onAddProduct" style="cursor: pointer">clique para adicionar</strong>
    </div>
    <ModalAddProduct v-if="!boardArchived" ref="ModalAddProduct" :card="card" v-on:Reload="onReload" />
  </div>
</template>
<script>
import CrmDetailsProduct from './product.js'
export default CrmDetailsProduct
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/product/product.vue